import type { Season } from '@/types'

/**
 * Seasons data for the Infinite Voltage robotics team.
 */
export const seasons: Season[] = [
  {
    year: '2026',
    name: 'REBUILT',
    youtube: '_fybREErgyM',
    image: require('@/assets/season/rebuilt-logo-2026.png'),
    robot: 'Jackbot',
    pic: require('@/assets/season/robot2026.jpg'),
    features: ['Swerve Drive', 'Triple Shooter', 'Auto Targeting', 'Efficient Intake'],
    awards: []
  },
  {
    year: '2025',
    name: 'REEFSCAPE',
    youtube: 'YWbxcjlY9JY',
    image: require('@/assets/season/reefscape-logo-2025.png'),
    robot: 'Chum',
    pic: require('@/assets/season/robot2025.png'),
    features: ['Swerve Drive', 'Two coral autonomous', 'Elevator', 'Tilting Shooter'],
    awards: [
      'Event Winner: CHS District Pasadena MD',
      'Creativity Award sponsored by Rockwell Automation',
      'Alliance 7: CHS District Severn MD'
    ]
  },
  {
    year: '2024',
    name: 'CRESCENDO',
    youtube: '9keeDyFxzY4',
    image: require('@/assets/season/crescendo-logo-2024.png'),
    robot: 'Hyena',
    pic: require('@/assets/season/robot2024.jpg'),
    features: ['Swerve Drive', 'Two note Autonomous'],
    awards: [
      'Event Finalist: CHS District Severn MD',
      'Alliance Captain: CHS District Owings Mills MD'
    ]
  },
  {
    year: '2023',
    name: 'CHARGED UP',
    youtube: '0zpflsYc4PA',
    image: require('@/assets/season/chargedup-200-reverse.png'),
    robot: 'Armageddon',
    pic: require('@/assets/season/robot2023.jpg'),
    features: ['Claw', 'Turret', 'Hybrid Tank Drive', 'Two cube Autonomous'],
    awards: [
      'Alliance Captain: CHS District Alexandria, VA',
      'Event Finalist: CHS District Timonium MD',
      'CHS District Championship Qualifier'
    ]
  },
  {
    year: '2022',
    name: 'RAPID REACT',
    youtube: 'LgniEjI9cCM',
    image: require('@/assets/season/2022-frc-game-logo.jpg'),
    robot: 'Frogger',
    pic: require('@/assets/season/robot2022-climb2.jpg'),
    features: ['Excellent Climbing', 'Great Low Shooter', 'Low shot Autonomous'],
    awards: [
      'Alliance Captain: CHS Event 4 Washington, DC',
      'CHS District Championship Qualifier'
    ]
  },
  {
    year: '2020',
    name: 'Infinite Recharge',
    youtube: 'gmiYWTmFRVE',
    image: require('@/assets/season/2020-frc-game-logo.jpg'),
    robot: 'Yoshi',
    pic: require('@/assets/season/robot2020.jpg'),
    features: ['Powerful Shooter', 'Tank Drive'],
    awards: ['CHS District Championship Qualifier']
  },
  {
    year: '2019',
    name: 'DEEP SPACE',
    youtube: 'Mew6G_og-PI',
    image: require('@/assets/season/2019-frc-game-logo.jpg'),
    robot: 'Alex 5',
    pic: require('@/assets/season/robot2019.jpg'),
    features: ['Pneumatic Climbing', 'Tank Drive'],
    awards: [
      'Rookie All Star',
      'Rookie Inspiration',
      'CHS District Championship Qualifier'
    ]
  }
]
